export const GENERAL_QUESTIONS = [
  'What are trending home improvement projects for 2025?',
  'How can I make my home more energy efficient?',
  'Which BBQ grills are best for small patios?',
  'What are the most popular paint colors this year?',
  'What are the top 5 home maintenance tasks that homeowners forget?',
  'How do I repair a faucet?',
  'What are the top DIY hacks for renters?',
  'How can I organize my garage efficiently?',
  'What are the best tools for a beginner DIYer?',
  'How can I add more natural light to my space?',
  'What are some easy weekend projects to transform a space?',
  'What’s the easiest way to update my cabinets?',
  'What are creative storage ideas?',
  'What’s the best way to tackle multiple projects?',
  'What’s one quick win for my home today?',
  'How do I prevent mold and mildew in my bathroom?',
  'How do I clean hard-to-reach areas effectively?',
  'How can I make my kitchen more functional?',
  'What’s the best way to upgrade my bathroom?',
  'How do I make sure I get everything I need in one trip?',
  'How do I choose the right paint color for my room?',
  'What’s the most affordable way to update my bathroom?',
  'Which flooring options are the best for pet owners?',
  'What tools do I need for fall leaf cleanup?',
  'What can I do to keep leaves out of my gutters?',
  'How do I choose a leaf blower?',
  'What do I need for winterizing outdoor power equipment?',
  'How can I prepare my house for cold weather months?',
  'What types of home generators are available?',
  'How do I size a generator for my home?',
  'Should I cover my outdoor furniture over winter?',
  'How can I weatherproof wood furniture and decks for colder months?',
  'How can I better insulate my garage?',
  'What kind of decor is available for autumn?',
  'How do I choose a grill?',
  'Which window coverings help keep heat in during cooler months?',
  'How can I divert water away from my foundation?',
  'Which outdoor lighting makes the biggest impact?',
  'How do I create a cozy, inviting outdoor space for evenings?',
  'What are the best outdoor heaters for entertaining?',
];

export const PIP_QUESTIONS = [
  'What is the warranty on this item?',
  'What are the delivery options for this item?',
  'What do I need to know before using it?',
  'What do I need to know before I buy?',
  'What are the key features?',
  'What are the top uses for this product?',
  'Can this item be returned or exchanged?',
  'What are the key specifications?',
  'How soon can I get this delivered to my zip code?',
  'What is the delivery charge for this item?',
];
